<template>
</template>

<script>
import localstorageMixin from '@/mixins/localstorageMixin.js'
export default {
  name: 'FuelStore',
  mixins : [localstorageMixin],
  data() {
    return {
      timestamps:{
        dateKey:'month',
        from: moment().startOf('month').format("YYYY-MM-DD HH:mm:ss"),
        to: moment().endOf('month').format("YYYY-MM-DD HH:mm:ss"),
        },
      data:{
        RCGB: {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
        RMGB: {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
        WGB : {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
      }
    }
  },
  mounted(){
    console.log('Fuel Store Loaded')
    window.atlDebug = this
    this.loadData();
  },
  methods: {
    loadData: function(){
      if (!document.hasFocus())
        return;
        
      //Strip timezone from ts 
      //Not sure if this is needed since I'm get the ts from the server
      let  from = moment(this.timestamps.from).startOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      let  to = moment(this.timestamps.to).endOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      //Skip if from and to are the same
      if(from === to){
        console.log('skipping')
        return
      }

      console.log('from to', from, to);

      this.$locations.forEach(location=>{
      // ['RCGB', 'WGB'].forEach(location=>{
      // No clue why the above line doesn't work
        this._getData('/getFuelSalesSummary', 'fuel', location)
        // this._getData('/getFuelPrepaySalesSummary', 'fuelPrepay')
        // this._getData('/getStoreSalesSummary', 'store')
        // this._getData('/getStoreTotalSales', 'totalSales')
        // this._getData('/getDistributorSalesSummary', 'distributors')
      })
    },

    _getData(endpoint, dataKey, location){
      this.data[location][dataKey] = {}
      this.data[location].isLoading = true;
      this.$axios.post(endpoint, { location, from: this.timestamps.from, to: this.timestamps.to }).then((r)=>{
        this.data[location].isLoading = false;
        this.data[location][dataKey] = r.data.length > 0 ? r.data[0] : this.data[location][dataKey]
        this.$emit('input', this.data)
      });
    }
  },
  computed:{

  },
}
</script>